module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "wrap"
  }, [_c('el-col', {
    staticClass: "warp-breadcrum",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("文件管理")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "wrap-main",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "size": "small",
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input')], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-upload', {
    attrs: {
      "before-upload": _vm.beforeUpload,
      "action": _vm.uploadUrl,
      "data": _vm.uploadData,
      "headers": _vm.uploadHeaders,
      "on-success": _vm.onSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("上传")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fileRows,
      "border": "",
      "size": "small"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "预览"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": scope.row.url,
            "width": "70",
            "height": "50"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "prop": "type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type === 1) ? _c('el-tag', [_vm._v("图片")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "路径",
      "prop": "url"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "创建日期",
      "prop": "createDate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeFile(scope.row.id)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": _vm.limit,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.search
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d895f888"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file/List.vue
// module id = 1194
// module chunks = 2